import { render } from "./VehicleCardPlaceholder.vue?vue&type=template&id=8d17d4ac"
import script from "./VehicleCardPlaceholder.vue?vue&type=script&lang=js"
export * from "./VehicleCardPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSkeleton});
